import React from 'react';
import PropTypes from 'prop-types';

import CUI_CONST from './CiscoUIConstants';

import Icon from './Icon';
import useXapi from '../../Hooks/useXapi';

const Button = props => {
  const { xApiEvent } = useXapi();
  const { disabled, size, color, icon, label, children } = props;

  let classes = ['btn', `btn--${size}`];

  if (color) {
    classes.push(`btn--${color}`);
  }

  if (icon) {
    classes.push(`btn--icon`);
  }
  const sendXAPIStatement = icon => {
    var message = ' modal opened';
    switch (icon) {
      case 'recent-apps':
        message = 'Recently Viewed Pages' + message;
        break;
      case 'bookmark':
        message = 'Bookmarks' + message;
        break;
      case 'list-view':
        message = 'Course Index' + message;
        break;
      case 'search':
        message = 'Search' + message;
        break;
      case 'language':
        message = 'Languages' + message;
        break;
      default:
        break;
    }
    xApiEvent(message, window.location.href);
  };
  return (
    <button
      className={classes.join(' ')}
      disabled={disabled}
      {...props}
      onClick={e => {
        // eslint-disable-next-line no-console
        sendXAPIStatement(props.icon);
        if (props.onClick) props.onClick();
      }}
    >
      {icon && <Icon icon={icon} />}
      {label}
      {children}
    </button>
  );
};

Button.defaultProps = {
  color: 'default',
  label: null,
  disabled: false,
  icon: null,
  size: 'default'
};

Button.propTypes = {
  color: PropTypes.oneOf(CUI_CONST.BUTTON_COLORS),
  label: PropTypes.string,
  disabled: PropTypes.bool,
  icon: PropTypes.string,
  size: PropTypes.oneOf(CUI_CONST.BUTTON_SIZES)
};

export default Button;
